import { Components } from "@mui/material/styles";

export const MuiPaper: Components["MuiPaper"] = {
    styleOverrides: {
        root: {
            backgroundColor: "white",
        },
        rounded: {
            borderRadius: "8px",
        },
    },
};
